export default __webpack_public_path__ + "static/media/Pot3.39feca9e.svg";